import {
  Box,
  Container,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Typography
} from "@mui/material/";
import { useSendPushNotification } from "../../services";
import { useForm } from "react-hook-form";
import LoadingButton from "@mui/lab/LoadingButton";

type FormValues = {
  title: string;
  body: string;
};

const Notifications = () => {
  const { mutateAsync: push, isLoading } = useSendPushNotification();

  const {
    control,
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<FormValues>();

  const onSubmit = async (data: FormValues) => {
    const { title, body } = data;
    try {
      // Create an array of push notification promises for tokens that exist
      return await push({
        title,
        body
      });
    } catch (error) {
      console.error("Error sending notifications:", error);
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        minHeight: {
          xs: "calc(100vh - 56px - 56px)",
          md: "calc(100vh - 69px - 56px)"
        },
        position: "relative",
        px: 0,
        py: 4
      }}
    >
      <Box
        component="form"
        className="today"
        bgcolor="background.default"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        p={2}
        width="100%"
        gap={3}
        onSubmit={handleSubmit(onSubmit)}
        sx={{ borderRadius: 2, boxShadow: 10 }}
      >
        <Typography variant="h5" fontWeight={600}>
          Invia notifica
        </Typography>
        <FormControl id={"title"} variant="outlined" fullWidth>
          <InputLabel htmlFor="outlined-adornment-password">Titolo</InputLabel>
          <OutlinedInput
            id="title"
            type={"text"}
            label="Titolo"
            required
            fullWidth
            autoComplete="current-password"
            error={!!errors.title}
            disabled={isLoading}
            {...register("title", {
              required: "campo obbligatorio"
            })}
          />
          {errors.title && (
            <FormHelperText error>{errors.title.message}</FormHelperText>
          )}
        </FormControl>
        <FormControl id={"body"} variant="outlined" fullWidth>
          <InputLabel htmlFor="outlined-adornment-password">
            Messaggio
          </InputLabel>
          <OutlinedInput
            id="body"
            type={"text"}
            label="Messaggio"
            multiline
            minRows={5}
            required
            fullWidth
            disabled={isLoading}
            error={!!errors.body}
            {...register("body", {
              required: "campo obbligatorio"
            })}
          />
          {errors.body && (
            <FormHelperText error>{errors.body.message}</FormHelperText>
          )}
        </FormControl>
        <LoadingButton
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2, width: "100%" }}
          loading={isLoading}
        >
          Invia
        </LoadingButton>
      </Box>
    </Container>
  );
};

export default Notifications;
